import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/blog";

export default function SEOArticlesSection() {
  const articles = allArticles.slice(0, 9);

  return (
    <section className="relative w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-50">
      {/* Header */}
      <div className="mb-10 md:mb-14">
        <div className="inline-flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded-lg bg-accent-200 flex items-center justify-center">
            <i className="ri-article-fill text-accent-700 text-lg"></i>
          </div>
          <span className="text-xs font-semibold text-accent-700 whitespace-nowrap">Artigos SEO</span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
          Guia Completo de{" "}
          <span className="italic font-normal">Compras na China</span>
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl leading-relaxed">
          Artigos detalhados para ajudar você a comprar melhor usando a <strong>planilha CSSBuy</strong>. Dicas, comparações e tutoriais atualizados.
        </p>
      </div>

      {/* Articles Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/artigo/${article.slug}`}
            className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/50 group cursor-pointer transition-all hover:border-accent-300 flex flex-col"
          >
            {/* Image */}
            <div className="h-48 md:h-52 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            {/* Content */}
            <div className="p-5 md:p-6 flex flex-col justify-between flex-1">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs font-semibold text-accent-700 bg-accent-100 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2 leading-snug group-hover:text-accent-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.intro}
                </p>
              </div>
              <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 mt-4 whitespace-nowrap group-hover:text-accent-700 transition-colors">
                Ler artigo completo
                <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>

      {/* View all link */}
      <div className="text-center mt-10">
        <p className="text-sm text-foreground-400">
          Navegue pelo menu <strong className="text-foreground-700">Guia de Compras</strong> para ver todos os artigos.
        </p>
      </div>
    </section>
  );
}